import * as React from 'react';

import { SocrativeLogo } from './SocrativeLogo';

export function SocrativeLoginLogo() {
  return (
    <div style={{ paddingBottom: 16, paddingTop: 16 }}>
      {/* To match the height of the old logo */}
      <SocrativeLogo />
    </div>
  );
}
